import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionPlantLocationTypePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-biggest-challenge-intro')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionPlantLocationType.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionPlantLocationType.indoorOnly'),
          value: 'indoor_only',
        },
        {
          text: t('pages.onboarding.questionPlantLocationType.outdoorOnly'),
          value: 'outdoor_only',
        },
        {
          text: t(
            'pages.onboarding.questionPlantLocationType.bothIndoorOutdoor',
          ),
          value: 'both',
        },
        {
          text: t('pages.onboarding.questionPlantLocationType.planningToStart'),
          value: 'planning',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
